import {
  Box,
  Typography,
  Paper,
  Link,
  Stack
} from "@mui/material";

export default function Contact() {
  return (
    <Box
      sx={{
        maxWidth: 900,
        mx: "auto",
        px: 3,
        py: 4,
      }}
    >
      <Typography
        variant="h4"
        component="h1"
        sx={{
          fontWeight: "bold",
          mb: 4,
          textAlign: "center",
          fontSize: {
            xs: "2rem",
            md: "3rem",
          },
        }}
      >
        Nous contacter
      </Typography>

      <Paper
        elevation={2}
        sx={{
          p: 4,
          borderRadius: 3,
        }}
      >
        <Typography
          variant="body1"
          sx={{
            mb: 4,
            lineHeight: 1.8,
          }}
        >
          Pour toute question concernant l'Open International de
          Sambreville ou le Judo Club Sambreville, vous pouvez nous
          contacter via les coordonnées ci-dessous.
        </Typography>

        <Stack spacing={3}>
          <Box>
            <Typography variant="h6" fontWeight="bold">
              📧 Email
            </Typography>
            <Link href="mailto:judo.club.sambreville@gmail.com" underline="hover">
              judo.club.sambreville@gmail.com
            </Link>
          </Box>

          <Box>
            <Typography variant="h6" fontWeight="bold">
              📞 Téléphone
            </Typography>
            <Link href="tel:+32477508158" underline="hover">
              0477/50 81 58
            </Link>
          </Box>

          <Box>
            <Typography variant="h6" fontWeight="bold">
              📍 Dojo
            </Typography>
            <Link
              href="https://maps.google.com/?q=Place+Albert+1er+5A+5060+Falisolle"
              target="_blank"
              rel="noreferrer"
              underline="hover"
            >
              Place Albert 1er, 5A
              <br />
              5060 Falisolle
            </Link>
          </Box>

          <Box>
            <Typography variant="h6" fontWeight="bold">
              🏢 Numéro d'entreprise
            </Typography>

            <Typography>
              0448.475.540
            </Typography>
          </Box>

          {/* <Box>
            <Typography variant="h6" fontWeight="bold">
              📄 Documents
            </Typography>
          </Box>
          <Link href="/documents/ROI.pdf" target="_blank" rel="noreferrer" underline="hover">
              Consulter le règlement d'ordre intérieur
          </Link> */}
        </Stack>
      </Paper>
    </Box>
  );
}
